import { mxgraphInstance } from './mxgraphFactory';
/**
 * Shape
 */
export var mxActor = mxgraphInstance.mxActor;
export var mxArrow = mxgraphInstance.mxArrow;
export var mxArrowConnector = mxgraphInstance.mxArrowConnector;
export var mxCloud = mxgraphInstance.mxCloud;
export var mxConnector = mxgraphInstance.mxConnector;
export var mxCylinder = mxgraphInstance.mxCylinder;
export var mxDoubleEllipse = mxgraphInstance.mxDoubleEllipse;
export var mxEllipse = mxgraphInstance.mxEllipse;
export var mxHexagon = mxgraphInstance.mxHexagon;
export var mxImageShape = mxgraphInstance.mxImageShape;
export var mxLabel = mxgraphInstance.mxLabel;
export var mxLine = mxgraphInstance.mxLine;
export var mxMarker = mxgraphInstance.mxMarker;
export var mxPolyline = mxgraphInstance.mxPolyline;
export var mxRectangleShape = mxgraphInstance.mxRectangleShape;
export var mxRhombus = mxgraphInstance.mxRhombus;
export var mxShape = mxgraphInstance.mxShape;
export var mxStencil = mxgraphInstance.mxStencil;
export var mxStencilRegistry = mxgraphInstance.mxStencilRegistry;
export var mxSwimlane = mxgraphInstance.mxSwimlane;
export var mxText = mxgraphInstance.mxText;
export var mxTriangle = mxgraphInstance.mxTriangle;
//# sourceMappingURL=Shape.js.map